import { render, staticRenderFns } from "./Consult.vue?vue&type=template&id=b74fa408&"
import script from "./Consult.vue?vue&type=script&lang=js&"
export * from "./Consult.vue?vue&type=script&lang=js&"
import style0 from "./Consult.vue?vue&type=style&index=0&id=b74fa408&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports